import { TID } from './templateIds';

export const DEBUG = parseInt(process.env.REACT_APP_DEBUG) === 1;

export const STORAGE_APP_DOWNLOAD_LINK = 'app_download_link';

// console.log('DEBUG', DEBUG);

// export const AMPLITUDE_API_KEY = DEBUG
//   ? process.env.REACT_APP_AMPLITUDE_API_DEV_KEY
//   : process.env.REACT_APP_AMPLITUDE_API_KEY;

export const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY;

// export const REACT_APP_SENTRY_TRACK_NEW_RELEASE = process.env.REACT_APP_SENTRY_TRACK_NEW_RELEASE;
// export const REACT_APP_SENTRY_SECRET_TOKEN = process.env.REACT_APP_SENTRY_SECRET_TOKEN;
// export const REACT_APP_SENTRY_PROJECT_ID = process.env.REACT_APP_SENTRY_PROJECT_ID;
// export const REACT_APP_SENTRY_PUBLIC_KEY = process.env.REACT_APP_SENTRY_PUBLIC_KEY;

// export const ACCESS_TOKEN       = 'access_token';

export const DEFAULT_TEMPLATE_ID = TID.A;

export const DOWNLOAD_ONE_LINK = '//hubapp.onelink.me/ZKxz?pid=FB_W2A_iOS15';
// export const DOWNLOAD_ONE_LINK = '//hubapp.onelink.me/ZKxz?pid=FB_W2A_iOS15&af_sub4=3643'

export const CONTENT_TYPE_JSON = 'application/json;charset=utf-8';

export const DEBUG_PRICE_ID = 'price_1OQupMIQoDVQPlsmyxD5m8ZO';

/**
 * @description Time out in seconds
 */
export const GET_REQUEST_TIMEOUT = 10000;

export const HTTP_METHOD_GET = 'GET';
export const HTTP_METHOD_POST = 'POST';

export const OUT_FORMAT_TEXT = 'text';
export const OUT_FORMAT_BLOB = 'blob';
export const OUT_FORMAT_JSON = 'json';

// export const PAYMENT_TYPE_STRIPE = 'stripe';
// export const PAYMENT_TYPE_PAYPAL = 'paypal';

export const languageList = ['en', 'de', 'es', 'pt', 'ru', 'fr', 'it'];

export const QUIZ_ROUTE = 'q';

export const cancelFlowRoutesMap = {
  pause: 'pause',
  pauseConfirm: 'pause-confirm',
  howImprove: 'how-improve',
  dontUse: 'dont-use',
  tryAgain: 'try-again',
  shareThoughts: 'share-thoughts',
  creatingOffer: 'creating-offer',
  updatingSubscription: 'updating-subscription',
  personalDiscount: 'personal-discount',
  sorryToYourGo: 'sorry-to-your-go',
  needMoreTime: 'need-more-time',
  wantForFree: 'want-for-free',
  alternativeApps: 'alternative-apps',
  didntLikeContent: 'didnt-like-content',
};

export const FLOW_LIST = ['default'];

export const POSITION = {
  LEFT: 'left',
  RIGHT: 'right',
};

export const EMAIL_REGEX =
  /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

export const LINKS = {
  TERMS: 'https://web.smmhub.app/manageSubscriptions/terms_of_use',
  PRIVACY: 'https://web.smmhub.app/manageSubscriptions/privacy_policy',
  SUBSCRIPTION:
    'https://web.smmhub.app/manageSubscriptions/subscription_policy',
  COOKIES: 'https://web.smmhub.app/manageSubscriptions/cookies_policy',
  MAILTO: 'mailto:support@smmhub.app',
};

export const LOGIN_BY_EMAIL =
  'https://grids.growthphotographers.com/v1/login_by_email';

export const PAYMENT_SYSTEM = {
  APPLE: 'apple_pay',
  PAYPAL: 'paypal',
  STRIPE: 'stripe',
};

export const EMAIL_DOMAINS = [
  'facebook.com',
  'verizon.net',
  'rediffmail.com',
  'zohomail.com',
  'zoho.com',
  'mail.com',
  'google.com',
  'comcast.com',
  'hotmail.co.uk',
  'yahoo.co.uk',
  'att.net',
  'gmz.com',
  'gmail.com',
  'hotmail.com',
  'yahoo.com',
  'outlook.com',
  'aol.com',
  'icloud.com',
  'live.com',
  'msn.com',
  'me.com',
  'mac.com',
  'googlemail.com',
];

export const AVAILABLE_PRICES_TO_UPGRADE_SUBSCRIPTION = {
  price_1OQrEBIQoDVQPlsmUbFsKPlg: {
    price_1QuwlUIQoDVQPlsmg6tZo2g3: true,
    price_1QnKQqIQoDVQPlsmP92UzNNo: true,
    price_1QUUopIQoDVQPlsmj7aPCysZ: true,
  },
  price_1OmddRIQoDVQPlsm16q4Zvxb: {
    price_1QuwlUIQoDVQPlsmg6tZo2g3: true,
    price_1QnKQqIQoDVQPlsmP92UzNNo: true,
    price_1QUUopIQoDVQPlsmj7aPCysZ: true,
  },
  price_1QzJYkIQoDVQPlsmTbtZtIY5: {
    price_1QzJXhIQoDVQPlsmY9PaSN6X: true,
    price_1RRAoFIQoDVQPlsmLy8swlaq: true,
  },
};

export const UPSELLS_PRICES = {
  allInOne: {
    priceId: 'price_1RMT0vIQoDVQPlsm7vErx7p1',
    prevPrice: 69.98,
    price: 24.99,
    image: 'assets/images/upsells/64-percent-sale.png',
    name: 'upsellsPage.all_in_one_pack',
    description: 'upsellsPage.all_in_one_pack_description',
  },
  promptsLibrary: {
    priceId: 'price_1Qx2WTIQoDVQPlsmaQBfhKah',
    prevPrice: 29.99,
    price: 14.99,
    image: 'assets/images/upsells/content-creation.png',
    name: 'upsellsPage.prompts_library',
  },
  pdfGuides: {
    priceId: 'price_1R6TR7IQoDVQPlsmslAgcRTz',
    prevPrice: 39.99,
    price: 19.99,
    image: 'assets/images/upsells/pdg-guides.png',
    name: 'upsellsPage.pdf_guides',
  },
};

// export const PRICES_FOR_PAYMENT_ID = {
// HT9T45: {
//   letter: 'HT9T45',
//   templateId: 'HT9T45',
//   stripe: 'price_1QUUopIQoDVQPlsmj7aPCysZ',
//   paypal: 'P-6FD03606MP5245234M5MFNJI',
//   price: '39.99',
//   prevPrice: '49.99',
//   per: '1 month',
//   trial: '7 day',
//   trialPrice: '0.99',
//   payWallText: 'paywallPage.subscription_info',
//   applePay: (t, startingOn) => ({
//     total: {
//       label: t('applePay.total_label.HT9T45'),
//       amount: parseFloat(PRICES_FOR_PAYMENT_ID.HT9T45.trialPrice) * 100,
//     },
//     displayItems: [
//       {
//         label: t('applePay.displayItems.HT9T45.0'), // 'Monthly subscription with 7 days just $0.99 trial period then $29.99/month',
//         amount: parseFloat(PRICES_FOR_PAYMENT_ID.HT9T45.trialPrice) * 100,
//       },
//       {
//         label: t(`applePay.displayItems.HT9T45.1`, { startingOn }), // 'Monthly subscription with 7 days just $0.99 trial period then $29.99/month',
//         amount: parseFloat(PRICES_FOR_PAYMENT_ID.HT9T45.price) * 100,
//       },
//     ],
//   }),
// },
// J7C4HK: {
//   letter: 'J7C4HK',
//   templateId: 'J7C4HK',
//   stripe: 'price_1QnKQqIQoDVQPlsmP92UzNNo',
//   paypal: 'P-701221214N565892UM6ONDWI',
//   price: '39.99',
//   prevPrice: '49.99',
//   per: '1 month',
//   trial: '7 day',
//   trialPrice: '6.99',
//   payWallText: 'paywallPage.subscription_info',
//   applePay: (t, startingOn) => ({
//     total: {
//       label: t('applePay.total_label.J7C4HK'),
//       amount: parseFloat(PRICES_FOR_PAYMENT_ID.J7C4HK.trialPrice) * 100,
//     },
//     displayItems: [
//       {
//         label: t('applePay.displayItems.J7C4HK.0'), // 'Monthly subscription with 7 days just $6.99 trial period then $29.99/month',
//         amount: parseFloat(PRICES_FOR_PAYMENT_ID.J7C4HK.trialPrice) * 100,
//       },
//       {
//         label: t(`applePay.displayItems.J7C4HK.1`, { startingOn }), // 'Monthly subscription with 7 days just $6.99 trial period then $29.99/month',
//         amount: parseFloat(PRICES_FOR_PAYMENT_ID.J7C4HK.price) * 100,
//       },
//     ],
//   }),
// },
// D2M99Z: {
//   letter: 'D2M99Z',
//   templateId: 'D2M99Z',
//   stripe: 'price_1QnKQqIQoDVQPlsmP92UzNNo',
//   paypal: 'P-701221214N565892UM6ONDWI',
//   price: '39.99',
//   prevPrice: '39.99',
//   per: '1 month',
//   trial: '7 day',
//   trialPrice: '6.99',
//   prevTrialPrice: '13.99',
//   payWallText: 'paywallPage.subscription_info',
//   applePay: (t, startingOn) => ({
//     total: {
//       label: t('applePay.total_label.D2M99Z'),
//       amount: parseFloat(PRICES_FOR_PAYMENT_ID.D2M99Z.trialPrice) * 100,
//     },
//     displayItems: [
//       {
//         label: t('applePay.displayItems.D2M99Z.0'), // 'Monthly subscription with 7 days just $6.99 trial period then $29.99/month',
//         amount: parseFloat(PRICES_FOR_PAYMENT_ID.D2M99Z.trialPrice) * 100,
//       },
//       {
//         label: t(`applePay.displayItems.D2M99Z.1`, { startingOn }), // 'Monthly subscription with 7 days just $6.99 trial period then $29.99/month',
//         amount: parseFloat(PRICES_FOR_PAYMENT_ID.D2M99Z.price) * 100,
//       },
//     ],
//   }),
// },
// '63C1Z7': {
//   letter: '63C1Z7',
//   templateId: '63C1Z7',
//   stripe: 'price_1QnKQqIQoDVQPlsmP92UzNNo',
//   paypal: 'P-701221214N565892UM6ONDWI',
//   price: '39.99',
//   prevPrice: '39.99',
//   per: '1 month',
//   trial: '7 day',
//   trialPrice: '6.99',
//   prevTrialPrice: '13.99',
//   payWallText: 'paywallPage.subscription_info',
//   applePay: (t, startingOn) => ({
//     total: {
//       label: t('applePay.total_label.D2M99Z'),
//       amount: parseFloat(PRICES_FOR_PAYMENT_ID['63C1Z7'].trialPrice) * 100,
//     },
//     displayItems: [
//       {
//         label: t('applePay.displayItems.D2M99Z.0'), // 'Monthly subscription with 7 days just $6.99 trial period then $29.99/month',
//         amount: parseFloat(PRICES_FOR_PAYMENT_ID['63C1Z7'].trialPrice) * 100,
//       },
//       {
//         label: t(`applePay.displayItems.D2M99Z.1`, { startingOn }), // 'Monthly subscription with 7 days just $6.99 trial period then $29.99/month',
//         amount: parseFloat(PRICES_FOR_PAYMENT_ID['63C1Z7'].price) * 100,
//       },
//     ],
//   }),
//   enableTiktokAnalytics: true,
// },
// KR22P9: {
//   letter: 'KR22P9',
//   templateId: 'KR22P9',
//   stripe: 'price_1QuwlUIQoDVQPlsmg6tZo2g3',
//   paypal: 'P-2PM91624CR562592MMXLWHHQ',
//   price: '29.99',
//   prevPrice: '29.99',
//   per: '1 month',
//   trial: '7 day',
//   trialPrice: '6.99',
//   prevTrialPrice: '13.99',
//   payWallText: 'paywallPage.subscription_info',
//   applePay: (t, startingOn) => ({
//     total: {
//       label: t('applePay.total_label.D2M99Z'),
//       amount: parseFloat(PRICES_FOR_PAYMENT_ID['KR22P9'].trialPrice) * 100,
//     },
//     displayItems: [
//       {
//         label: t('applePay.displayItems.D2M99Z.0'), // 'Monthly subscription with 7 days just $6.99 trial period then $29.99/month',
//         amount: parseFloat(PRICES_FOR_PAYMENT_ID['KR22P9'].trialPrice) * 100,
//       },
//       {
//         label: t(`applePay.displayItems.D2M99Z.1`, { startingOn }), // 'Monthly subscription with 7 days just $6.99 trial period then $29.99/month',
//         amount: parseFloat(PRICES_FOR_PAYMENT_ID['KR22P9'].price) * 100,
//       },
//     ],
//   }),
//   enableTiktokAnalytics: false,
// },
// Z73CMZ: {
//   letter: 'Z73CMZ',
//   templateId: 'Z73CMZ',
//   stripe: 'price_1QuwlUIQoDVQPlsmg6tZo2g3',
//   paypal: 'P-2PM91624CR562592MMXLWHHQ',
//   price: '29.99',
//   prevPrice: '29.99',
//   per: '1 month',
//   trial: '7 day',
//   trialPrice: '6.99',
//   prevTrialPrice: '13.99',
//   payWallText: 'paywallPage.subscription_info',
//   applePay: (t, startingOn) => ({
//     total: {
//       label: t('applePay.total_label.D2M99Z'),
//       amount: parseFloat(PRICES_FOR_PAYMENT_ID['Z73CMZ'].trialPrice) * 100,
//     },
//     displayItems: [
//       {
//         label: t('applePay.displayItems.D2M99Z.0'), // 'Monthly subscription with 7 days just $6.99 trial period then $29.99/month',
//         amount: parseFloat(PRICES_FOR_PAYMENT_ID['Z73CMZ'].trialPrice) * 100,
//       },
//       {
//         label: t(`applePay.displayItems.D2M99Z.1`, { startingOn }), // 'Monthly subscription with 7 days just $6.99 trial period then $29.99/month',
//         amount: parseFloat(PRICES_FOR_PAYMENT_ID['Z73CMZ'].price) * 100,
//       },
//     ],
//   }),
//   enableTiktokAnalytics: true,
// },
// 99999: {
//   letter: 99999,
//   templateId: 99999,
//   stripe: process.env.REACT_APP_STRIPE_6_MONTHS,
//   paypal: process.env.REACT_APP_PAYPAL_6_MONTHS,
//   price: '29.99',
//   prevPrice: '39.99',
//   per: '6 months',
//   trial: '0 day',
//   trialPrice: 0,
//   payWallText:
//     "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 7 day introductory offer, you will automatically be charged the full price of the subscription at $29.99 per 1 month until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
//   applePay: (startingOn) => ({
//     total: {
//       label: '6 Months subscription',
//       amount: 2999,
//     },
//     displayItems: [
//       {
//         label: `6 Month Plan: Starting on ${startingOn}`,
//         amount: 2999,
//       },
//     ],
//   }),
// },
// 1: {
//   letter: 1,
//   templateId: 3,
//   stripe: process.env.REACT_APP_STRIPE_LETTER_01,
//   paypal: process.env.REACT_APP_PAYPAL_LETTER_01,
//   price: '29.99',
//   prevPrice: '39.99',
//   per: '1 month',
//   trial: '7 day',
//   trialPrice: 0,
//   payWallText:
//     "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 7 day introductory offer, you will automatically be charged the full price of the subscription at $29.99 per 1 month until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
//   applePay: (t, startingOn) => ({
//     total: {
//       label: t('applePay.total_label.1'),
//       amount: 0,
//       // type: 'pending'
//     },
//     displayItems: [
//       {
//         label: t(`applePay.displayItems.1.0`, { startingOn }),
//         amount: 0,
//         // type: 'final'
//       },
//       {
//         label: t(`applePay.displayItems.1.1`, { startingOn }),
//         amount: 2999,
//         // type: 'final'
//       },
//     ],
//   }),
// },
// 2: {
//   letter: 2,
//   templateId: 4,
//   stripe: process.env.REACT_APP_STRIPE_LETTER_02,
//   paypal: process.env.REACT_APP_PAYPAL_LETTER_02,
//   price: '29.99',
//   prevPrice: '39.99',
//   per: '3 month',
//   trial: '14 day',
//   trialPrice: 0,
//   payWallText:
//     "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 14 day introductory offer, you will automatically be charged the full price of the subscription at $29.99 per 3 months until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
//   applePay: (t, startingOn) => ({
//     total: {
//       label: t('applePay.total_label.2'),
//       amount: 0,
//     },
//     displayItems: [
//       {
//         label: t(`applePay.displayItems.2.0`, { startingOn }),
//         amount: 0,
//       },
//       {
//         label: t(`applePay.displayItems.2.1`, { startingOn }),
//         amount: 2999,
//       },
//     ],
//   }),
// },
// 3: {
//   letter: 3,
//   templateId: 5,
//   stripe: process.env.REACT_APP_STRIPE_LETTER_02,
//   paypal: process.env.REACT_APP_PAYPAL_LETTER_02,
//   price: '29.99',
//   prevPrice: '39.99',
//   per: '3 month',
//   trial: '14 day',
//   trialPrice: 0,
//   payWallText:
//     "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 14 day introductory offer, you will automatically be charged the full price of the subscription at $29.99 per 3 months until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
//   applePay: (startingOn) => ({
//     total: {
//       label: `3 Months subscription with ${PRICES_FOR_PAYMENT_ID['3']?.trial} trial period`,
//       amount: 0,
//     },
//     displayItems: [
//       {
//         label: 'Special Offer: 14 days trial period',
//         amount: 0,
//       },
//       {
//         label: `3 Month Plan: Starting on ${startingOn}`,
//         amount: 2999,
//       },
//     ],
//   }),
// },
// 4: {
//   letter: 4,
//   templateId: 6,
//   stripe: process.env.REACT_APP_STRIPE_LETTER_01,
//   paypal: process.env.REACT_APP_PAYPAL_LETTER_01,
//   price: '29.99',
//   prevPrice: '39.99',
//   per: '1 month',
//   trial: '7 day',
//   trialPrice: 0,
//   payWallText:
//     "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 7 day introductory offer, you will automatically be charged the full price of the subscription at $29.99 per 1 month until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
//   applePay: (startingOn) => ({
//     total: {
//       label: `1 Months subscription with ${PRICES_FOR_PAYMENT_ID['4']?.trial} trial period`,
//       amount: 0,
//     },
//     displayItems: [
//       {
//         label: 'Special Offer: 7 days trial period',
//         amount: 0,
//       },
//       {
//         label: `1 Month Plan: Starting on ${startingOn}`,
//         amount: 2999,
//       },
//     ],
//   }),
// },
// 5: {
//   letter: 5,
//   templateId: 7,
//   stripe: process.env.REACT_APP_STRIPE_LETTER_02,
//   paypal: process.env.REACT_APP_PAYPAL_LETTER_02,
//   price: '29.99',
//   prevPrice: '39.99',
//   per: '3 months',
//   trial: '14 day',
//   trialPrice: 0,
//   payWallText:
//     "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 14 day introductory offer, you will automatically be charged the full price of the subscription at $29.99 per 3 months until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
//   applePay: (startingOn) => ({
//     total: {
//       label: `3 Months subscription with ${PRICES_FOR_PAYMENT_ID['5']?.trial} trial period`,
//       amount: 0,
//     },
//     displayItems: [
//       {
//         label: 'Special Offer: 14 days trial period',
//         amount: 0,
//       },
//       {
//         label: `3 Month Plan: Starting on ${startingOn}`,
//         amount: 2999,
//       },
//     ],
//   }),
// },
// 6: {
//   letter: 6,
//   templateId: 8,
//   stripe: process.env.REACT_APP_STRIPE_LETTER_02,
//   paypal: process.env.REACT_APP_PAYPAL_LETTER_02,
//   price: '29.99',
//   prevPrice: '39.99',
//   per: '3 months',
//   trial: '14 day',
//   trialPrice: 0,
//   payWallText:
//     "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 14 day introductory offer, you will automatically be charged the full price of the subscription at $29.99 per 3 months until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
//   applePay: (startingOn) => ({
//     total: {
//       label: `3 Months subscription with ${PRICES_FOR_PAYMENT_ID['6']?.trial} trial period`,
//       amount: 0,
//     },
//     displayItems: [
//       {
//         label: 'Special Offer: 7 days trial period',
//         amount: 0,
//       },
//       {
//         label: `3 Month Plan: Starting on ${startingOn}`,
//         amount: 2999,
//       },
//     ],
//   }),
// },
// 7: {
//   letter: 7,
//   templateId: 9,
//   stripe: process.env.REACT_APP_STRIPE_LETTER_07,
//   paypal: process.env.REACT_APP_PAYPAL_LETTER_07,
//   price: '89.99',
//   prevPrice: '129.99',
//   per: '1 year',
//   trial: '14 day',
//   trialPrice: 0,
//   payWallText:
//     "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 14 day introductory offer, you will automatically be charged the full price of the subscription at $89.99 per 1 year until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
//   applePay: (t, startingOn) => ({
//     total: {
//       label: t('applePay.total_label.7'),
//       amount: 0,
//     },
//     displayItems: [
//       {
//         label: t(`applePay.displayItems.7.0`, { startingOn }),
//         amount: 0,
//       },
//       {
//         label: t(`applePay.displayItems.7.1`, { startingOn }),
//         amount: 8999,
//       },
//     ],
//   }),
// },
// 8: {
//   letter: 8,
//   templateId: 10,
//   stripe: process.env.REACT_APP_STRIPE_LETTER_07,
//   paypal: process.env.REACT_APP_PAYPAL_LETTER_07,
//   price: '89.99',
//   prevPrice: '129.99',
//   per: '1 year',
//   trial: '14 day',
//   trialPrice: 0,
//   payWallText:
//     "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 14 day introductory offer, you will automatically be charged the full price of the subscription at $89.99 per 1 year until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
//   applePay: (startingOn) => ({
//     total: {
//       label: `1 Year subscription with ${PRICES_FOR_PAYMENT_ID['8']?.trial} trial period`,
//       amount: 0,
//     },
//     displayItems: [
//       {
//         label: 'Special Offer: 14 days trial period',
//         amount: 0,
//       },
//       {
//         label: `1 Year Plan: Starting on ${startingOn}`,
//         amount: 8999,
//       },
//     ],
//   }),
// },
// 9: {
//   letter: 9,
//   templateId: 11,
//   stripe: process.env.REACT_APP_STRIPE_LETTER_09,
//   paypal: process.env.REACT_APP_PAYPAL_LETTER_09,
//   price: '89.99',
//   prevPrice: '129.99',
//   per: '1 year',
//   trial: '1 month',
//   trialPrice: 0,
//   payWallText:
//     "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 1 month free introductory offer, you will automatically be charged the full price of the subscription at $89.99 per 1 year until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
//   applePay: (startingOn) => ({
//     total: {
//       label: `1 Year subscription with ${PRICES_FOR_PAYMENT_ID['9']?.trial} trial period`,
//       amount: 0,
//     },
//     displayItems: [
//       {
//         label: 'Special Offer: 1 month trial period',
//         amount: 0,
//       },
//       {
//         label: `1 Year Plan: Starting on ${startingOn}`,
//         amount: 8999,
//       },
//     ],
//   }),
// },
// 11: {
//   letter: 10,
//   templateId: 13,
//   stripe: process.env.REACT_APP_STRIPE_LETTER_11,
//   paypal: process.env.REACT_APP_PAYPAL_LETTER_11,
//   price: '29.99',
//   prevPrice: '39.99',
//   per: '1 year',
//   trial: '1 month',
//   trialPrice: 0,
//   payWallText:
//     "By pressing start my plan you agree that if you don't cancel at least 24 hours prior to the end of the 1 month free introductory offer, you will automatically be charged the full price of the subscription at $29.99 per 1 year until you cancel subscription in settings. Learn more about cancellation and refund policy in our Terms of Use.",
//   applePay: (startingOn) => ({
//     total: {
//       label: `1 Year subscription with ${PRICES_FOR_PAYMENT_ID['11']?.trial} trial period`,
//       amount: 0,
//     },
//     displayItems: [
//       {
//         label: 'Special Offer: 1 months trial period',
//         amount: 0,
//       },
//       {
//         label: `1 Year Plan: Starting on ${startingOn}`,
//         amount: 2999,
//       },
//     ],
//   }),
// },
// };

export const SUBMIT_PAYMENT_ERROR_MESSAGES =
  'Please check your card number, expiration date, CVV or try another card.';

export const SUBSCRIPTIONS_NAMES = {
  'P-6HH43248N2891443BMWGCEBY': 'subscriptionsNames.7_day_trial',
  'P-2PM91624CR562592MMXLWHHQ': 'subscriptionsNames.7_day_trial',
  price_1P4JCjIQoDVQPlsm0ntz0LYt: 'subscriptionsNames.7_day_trial',
  price_1PhnjDIQoDVQPlsml08YkvT8: 'subscriptionsNames.7_day_trial',
  price_1OQogwIQoDVQPlsmgTr1B3HO: 'subscriptionsNames.7_day_trial',
};

export const PAYMENT_PLANS = {
  '14.99/year': {
    price: '14.99',
    subscriptionLength: 1,
    per: 'year',
    planId: {
      stripe: 'price_1Q0PrpIQoDVQPlsmuLvA4YsR',
      paypal: 'P-19530085YG4602944M4DFQ6Q',
    },
    trial: null,
    trialPrice: null,
  },
  '29.99/month': {
    price: '29.99',
    per: 'month',
    planId: {
      stripe: 'price_1Q0PseIQoDVQPlsmB2imwe2A',
      paypal: 'P-88R17334SM398925MM4DFR7A',
    },
    trial: { price: '0', per: 'day', trialLength: 30 },
    trialPrice: null,
  },
};
